import React from 'react';
import PropTypes from 'prop-types';

import HelptextTooltip from 'common/components/helptext-tooltip';

export default class FormFieldLabel extends React.Component {
  static propTypes = {
    forId: PropTypes.string,
    label: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
  };

  render() {
    return (
      <label className={'FormFieldLabel'} htmlFor={this.props.forId}>
        <span className={'FormFieldLabel-label'}>{this.props.label}</span>
        {this.props.tooltip && (
          <span className={'FormFieldLabel-tooltip'}>
            <HelptextTooltip>{this.props.tooltip}</HelptextTooltip>
          </span>
        )}
      </label>
    );
  }
}
